var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrushBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconsax/Linear/brushbig"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.875 24.375V22.5H5.625C4.9375 22.5 4.3125 22.225 3.8625 21.7625C3.4 21.3125 3.125 20.6875 3.125 20C3.125 18.7125 4.125 17.6375 5.3875 17.5125C5.4625 17.5 5.5375 17.5 5.625 17.5H24.375C24.4625 17.5 24.5375 17.5 24.6125 17.5125C25.2125 17.5625 25.7375 17.825 26.1375 18.2375C26.65 18.7375 26.925 19.45 26.8625 20.225C26.75 21.5375 25.5625 22.5 24.2375 22.5H18.125V24.375C18.125 25.2038 17.7958 25.9987 17.2097 26.5847C16.6237 27.1708 15.8288 27.5 15 27.5C14.1712 27.5 13.3763 27.1708 12.7903 26.5847C12.2042 25.9987 11.875 25.2038 11.875 24.375Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.2193 2V8.25M15.2318 2V4.5M25.4443 6.125L24.8443 17.0125C24.7693 17 24.6943 17 24.6068 17H5.85683C5.76933 17 5.69433 17 5.61933 17.0125L5.01933 6.125C4.96618 5.60391 5.02293 5.07747 5.18592 4.57968C5.34891 4.08189 5.61451 3.62382 5.96556 3.23508C6.31661 2.84633 6.7453 2.53555 7.22394 2.32281C7.70259 2.11006 8.22054 2.00009 8.74433 2H21.7193C23.9318 2 25.6693 3.9125 25.4443 6.125Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrushBig);
export default __webpack_public_path__ + "static/media/brushBig.219f89c6599abdf54e5ba851a77e634a.svg";
export { ForwardRef as ReactComponent };